import { useMemo } from 'react';

import { useFilterContext } from '../../../next/CustomDash/filters/contexts/FilterProvider';
import type { TaxonomyConfig } from '../../../next/CustomDash/filters/types/taxonomy';

/**
 * The activity slice of `TaxonomyConfig`, read off the enclosing
 * FilterProvider: the gate it resolved for THIS page (the page's unit of
 * analysis picks the activity filter flag, and an activity primary forces it
 * on) plus the current version. One hook so every filter-map factory call
 * site uses the provider's answer instead of re-deriving it from Unleash.
 */
export const useActivityTaxonomyConfig = (): Pick<
  TaxonomyConfig,
  'activityTaxonomyVersion' | 'activityTaxonomyEnabled'
> => {
  const { activityTaxonomyEnabled, activityTaxonomyVersion } =
    useFilterContext();
  // Stable identity so callers can put the config straight into deps arrays.
  return useMemo(
    () => ({ activityTaxonomyVersion, activityTaxonomyEnabled }),
    [activityTaxonomyVersion, activityTaxonomyEnabled]
  );
};
